const monetateConstant = {
  DECISION_REQUEST: 'monetate:decision:DecisionRequest',
  USER_AGENT: 'monetate:context:UserAgent',
  PAGE_VIEW: 'monetate:context:PageView',
  CUSTOM_VARIABLES: 'monetate:context:CustomVariables',
  CART_CONTEXT: 'monetate:context:Cart',
  ENDCAP_CLICKS: 'monetate:record:EndcapClicks',
  PRODUCT_DETAIL_VIEW: 'monetate:context:ProductDetailView',
  PRODUCT_THUMBNAIL_VIEW: 'monetate:context:ProductThumbnailView',
  ADD_TO_CART: 'monetate:context:AddToCart',
  PURCHASE: 'monetate:context:Purchase',
};

export default monetateConstant;
